import { render, staticRenderFns } from "./ScrollToBlock.vue?vue&type=template&id=4b3d87b2"
import script from "./ScrollToBlock.vue?vue&type=script&lang=js"
export * from "./ScrollToBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports